// IDX Broker widget configuration.
//
// Swell Realty's IDX Broker account subdomain (found on the current agent page:
// https://search.sellwithswell.com/idx/agent/15892256/jessica-burnette).
export const IDX_BROKER_SUBDOMAIN = 'sellwithswell.idxbroker.com';

// Jessica's IDX Broker agent ID (confirmed from her live agent page).
export const IDX_BROKER_AGENT_ID = '15892256';

// Widget IDs come from the IDX Broker dashboard.
// Ask Swell to send these; once populated, the corresponding sections light up.
// Format: a 5-6 char alphanumeric UID from the widget's "Publish" screen.
//
// Example filled value:  '12345'
// Example URL used:      //sellwithswell.idxbroker.com/idx/widgets/12345
export const IDX_WIDGETS = {
  // Auto-rotating slider of Jessica's featured listings.
  showcase: '', // TODO from Swell: Showcase widget filtered to agent 15892256

  // Grid of Jessica's active listings (self-updating).
  agentListings: '', // TODO from Swell: Agent Listings widget filtered to agent 15892256

  // Big single-input search that redirects to Swell's IDX results.
  omnibar: '', // TODO from Swell: Omnibar search widget
};
